export const parseCityOption = (city) => {
    let label = `${city.name}`;
    if (city.gmina_name) {
        label += `, gm. ${city.gmina_name}`;
    } else {
        label += `, pow. ${city.powiat_name}`;
    }
    label += `, woj. ${city.wojewodztwo_name}`;

    return {
        label,
        value: city.id,
    };
}

export const parseStreetOption = (street) => {
    return {
        label: `${street.cecha} ${street.nazwa_2 || ''} ${street.nazwa_1 || ''}`.trim(),
        value: street.id,
    }
}
